import api from 'common/api'
import { constant } from 'lodash'

const vanillaMessage = ({ message }) => message
export const types = {
  EnableCollegeAPIs: {
    typeName: 'CollegeEnableAPIIntegrationsRequested',
    subject: ({ ticketReporter, subjectContext }) =>
      `${ticketReporter} has requested that API integration be enabled for their college - ${subjectContext}`,
    message: ({ ticketReporter, subjectContext }) =>
      `Admissions Officer: ${ticketReporter} \nCollege: ${subjectContext}`,
  },
  CollegeSupportRequest: {
    typeName: 'CollegeSupportRequest',
    subject: ({ subjectContext }) => `College Update: ${subjectContext}`,
    message: vanillaMessage,
  },
  CollegeUserRoleRequest: {
    typeName: 'CollegeSupportRequest',
    subject: constant('College User Roles'),
    message: vanillaMessage,
  },
  CollegeApplicationRoundChangeRequest: {
    typeName: 'CollegeSupportRequest',
    subject: ({ subjectContext }) => `College Application Round Update: ${subjectContext}`,
    message: ({ ticketReporter, subjectContext }) =>
      `Admissions Officer ${ticketReporter} is requesting changes to application rounds for ${subjectContext}`,
  },
}

const generateTicket = (config) => {
  const type = types[config.type]
  const context = {
    ticketReporter: `${config.firstName} ${config.lastName} (${config.email})`,
    subjectContext: config.subjectContext,
    message: config.message,
  }
  return {
    Type: type.typeName,
    Subject: type.subject(context),
    Message: type.message(context),
  }
}

const getEndpoint = (type, scid) => {
  const defaultUrl = '/api/support/tickets'
  switch (type) {
    case 'CollegeSupportRequest':
      return `/api/support/tickets/university/${scid}`
    default:
      return defaultUrl
  }
}

export default (config) => api.post(getEndpoint(config.type, config.scid), generateTicket(config))
